var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollTop),expression:"scrollTop"}],staticClass:"btn btn-success text-center btn-scroll-top rounded-full fixed right-8 bottom-10 z-100",on:{"click":_vm.scrollToTop}},[_c('font-awesome-icon',{attrs:{"icon":"chevron-up","size":"lg"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }